export enum DateRangeType {
    Dynamic = 'Dynamic',
    FiscalYear = 'FiscalYear'
}
